import React, {Component} from "react";
import {connect} from "react-redux";
import {logoutUser, loginLink} from "../actions";
import {myFirebase} from "../firebase/firebase";
import SignUp from "./SignUp";
import {getUserDataByMail} from "../utils/utils";
import {LoopCircleLoading} from "react-loadingg";
import UserHome from "./UserHome";
import Container from "@material-ui/core/Container";
import setUser from "../actions/currUser";

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true
        }
    }

    handleLogout = () => {
        const {dispatch} = this.props;
        dispatch(logoutUser());
    };


    async componentDidMount() {
        let user;
        // sign in with google.
        if (myFirebase.auth().currentUser != null) {
            console.log(this.props.auth.user.email);
            this.state.userMail = myFirebase.auth().currentUser.email;
            user = await getUserDataByMail(this.state.userMail.toLowerCase());
            if (typeof (user) !== 'undefined') {
                this.props.setUser(user)
            }
            // sign in with magic link.
        } else {
            await new Promise(r => setTimeout(r, 1000));
            this.props.loginLink();
            await new Promise(r => setTimeout(r, 1000));
            this.state.userMail = window.localStorage.getItem('emailForSignIn');
            user = await getUserDataByMail(this.state.userMail.toLowerCase());
            if (typeof (user) !== 'undefined') {
                this.props.setUser(user)
            }

        }
        this.setState({isRegistered: typeof (user) !== 'undefined'});
        // if(this.state.isRegistered) {
        //     this.setState({userData: user});
        // }
        this.setState({isLoading: false});
    }

    render() {
        let show;
        if (this.state.isLoading) {
            show = <LoopCircleLoading/>;
        } else {
            if (this.state.isRegistered) {
                show = <UserHome/>;
            } else {
                show = <SignUp email={this.state.userMail}/>;
            }
        }
        return (
            <Container component="main" maxWidth="xs">
                {show}
            </Container>
        );
    }
}

function mapStateToProps(state) {
    return {
        isLoggingOut: state.auth.isLoggingOut,
        logoutError: state.auth.logoutError,
        auth: state.auth,
        currUser: state.currentUser
    };
}


const mapDispatchToProps = (dispatch) => {
    return {
        setUser: (user) => dispatch(setUser(user)),
        loginLink: () => dispatch(loginLink())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);